import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UpdateNotificationFormComponent } from './update-notification-form/update-notification-form.component';

const routes: Routes = [
  {
    path: 'delivery-notification',
    component: UpdateNotificationFormComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DeliveryNotificationRoutingModule { }
